import { make } from 'vuex-pathify';
import { filter, keyBy, keys, sortBy, values } from 'lodash';

const profiles = keyBy(
    [
        {
            id: 1,
            image: require('@/assets/profiles/profiles_0000_chestshot.png'),
            imageText: 'Nude chest shot',
            screenname: 'Downtown? 30',
            stats: '6’, 190 lbs, muscular',
            status: 'Dating',
            looking: 'Right Now',
            blurb:
                'I need a host downtown. I don’t send face pics so stop asking. Lookin’ for local host to explore with regularly. I’m vers and can be sub or dom, depending on what you like. Be fit, hung and local. Must be on PrEP or use condoms.',
            right:
                'OK, so let’s just be clear on what you may be getting… He might have something to hide because he didn’t show his profile picture. His relationship status is “dating” which means he may be in a few other intimate relationships. He’s looking for “Right Now” which means he might want to just be intimate at that time and who knows what happens later. He says, “must be on PrEP or use condoms” so he makes safer sex a priority.',
            left:
                'OK, sounds like he’s not the right one for you right now. Let’s see what you passed up… He might have something to hide because he didn’t show his profile picture. His relationship status is “dating” which means he may be in a few other intimate relationships. He’s looking for “Right Now” which means he might want to just be intimate at that time and who knows what happens later. He says, “must be on PrEP or use condoms” so he makes safer sex a priority.',
            swipe: ''
        },
        {
            id: 2,
            image: require('@/assets/profiles/profiles_0002_mountainguy.png'),
            imageText: 'Outdoorsy person sitting on a mountainside, face is showing (androgynous face)',
            screenname: 'Southy 32',
            stats: '5’10, 160 lbs',
            status: 'Single',
            looking: 'Chat, friends, networking and right now',
            blurb:
                'Just moved to Chicago, vers bottom, but just looking for trans friends right now. Not looking for hookups right now. Seriously please no cis men.',
            right:
                'OK, so let’s just be clear on what you may be getting… Their profile says they’re not looking for hookups, just friends, so they’re looking for people to get to know. They’re not looking for a quickie. They say “chat” too which means they might want to go at a slower pace. They also didn’t include any information about whether they uses PrEP or condoms, so safer sex options are not an obvious priority.',
            left:
                'OK, sounds like they’re not the right one for you right now. Let’s see what you passed up… Their profile says they’re not looking for hookups, just friends, so they’re looking for people to get to know. They’re not looking for a quickie. They say “chat” too which means they might want to go at a slower pace. They also didn’t include any information about whether they uses PrEP or condoms, so safer sex options are not an obvious priority.',
            swipe: ''
        },
        {
            id: 3,
            image: require('@/assets/profiles/profiles_0001_selfie.png'),
            imageText: 'Blurry face and body pic, dressed but holding up phone to block his face',
            screenname: 'Top4TravelNow 26',
            stats: '5’9’’, 170lbs, Latino vers top',
            status: '',
            looking: 'Right now',
            blurb:
                'Top passionate Latino lover looking to play now. Looking for party favors or to bring party favors. Very clean. Down for threesomes or group play. Love kissing, ass play, oral, touching and rimming. Down for regular things too. Chill and down to earth. Send pics so I know you’re serious.',
            right:
                'OK, so let’s just be clear on what you may be getting… So he didn’t say anything about getting to know you, so he might be just looking for sex or sex for pay. His whole description is about what he wants to do in the bedroom, so again this is very sex centric. He mentioned “party favors” so he may be expecting to use drugs in the context of sex. He also didn’t include any information about whether he uses PrEP or condoms, so safer sex options are not an obvious priority.',
            left:
                'OK, sounds like he’s not the right one for you right now. Let’s see what you passed up… So he didn’t say anything about getting to know you, so he might be just looking for sex or sex for pay. His whole description is about what he wants to do in the bedroom, so again this is very sex centric He mentioned “party favors” so he may be expecting to use drugs in the context of sex. He also didn’t include any information about whether he uses PrEP or condoms, so safer sex options are not an obvious priority.',
            swipe: ''
        }
    ],
    'id'
);
const profilesOrder = sortBy(keys(profiles), k => parseInt(k));

const state = {
    title: 'Red Flag, Green Flag',
    complete: false,
    sticker: {
        text: 'Red flag/Green flag',
        earned: false,
        image: require('@/assets/stickers/stickers_0007_flag.png')
    },
    bonusSticker: false,
    trophy: false,
    profiles,
    profilesOrder
};
const getters = {
    ...make.getters(state),
    allProfilesSwiped: state => {
        return 0 === filter(values(state.profiles), { swipe: '' }).length;
    }
};
const mutations = make.mutations(state);
const actions = make.actions(state);

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
